import { Check, Loader2, Circle } from "lucide-react";

// Ordered milestones displayed in every client project. Maps to backend PIPELINE_STAGES,
// enriched with user-facing labels the client actually cares about.
export const TIMELINE_MILESTONES = [
  { key: "Inquiry", label: "Consultation" },
  { key: "Qualified Lead", label: "Discovery Complete" },
  { key: "Consultation Scheduled", label: "Scope Confirmed" },
  { key: "Proposal Sent", label: "Proposal Sent" },
  { key: "Proposal Accepted", label: "Proposal Approved" },
  { key: "Deposit Paid", label: "Deposit Received" },
  { key: "Brand Development", label: "Product Specifications Confirmed" },
  { key: "Artwork Approval", label: "Artwork Submitted & Approved" },
  { key: "Production", label: "Production Scheduled" },
  { key: "Shipping", label: "Quality Review & Shipping" },
  { key: "Delivered", label: "Delivered" },
  { key: "Reorder", label: "Reorder Available" },
];

const ProjectTimeline = ({ stage, updatedAt }) => {
  const currentIdx = TIMELINE_MILESTONES.findIndex((m) => m.key === stage);

  return (
    <div className="ft-card" data-testid="project-timeline">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="ft-eyebrow">Project Timeline</div>
          <h3 className="text-lg font-semibold mt-1">From consultation to reorder</h3>
        </div>
        <div className="text-xs text-[var(--ft-muted)]">
          {updatedAt && <>Updated {new Date(updatedAt).toLocaleDateString()}</>}
        </div>
      </div>

      <ol className="relative">
        {TIMELINE_MILESTONES.map((m, i) => {
          const status = i < currentIdx ? "done" : i === currentIdx ? "current" : "pending";
          const isLast = i === TIMELINE_MILESTONES.length - 1;
          return (
            <li key={m.key} className="flex gap-4 pb-5 relative" data-testid={`timeline-${i}`}>
              {!isLast && (
                <span
                  aria-hidden
                  className="absolute left-[15px] top-8 bottom-0 w-px"
                  style={{ background: i < currentIdx ? "var(--ft-blue)" : "var(--ft-border)" }}
                />
              )}
              <div
                className="relative z-10 h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  background: status === "done" ? "var(--ft-blue)"
                    : status === "current" ? "rgba(11,95,165,0.12)"
                    : "var(--ft-soft-gray)",
                  border: status === "current" ? "2px solid var(--ft-blue)"
                    : status === "done" ? "2px solid var(--ft-blue)"
                    : "2px solid var(--ft-border)",
                }}
                data-testid={`timeline-dot-${m.key}`}
                data-status={status}
              >
                {status === "done" && <Check size={14} color="#fff" strokeWidth={3} />}
                {status === "current" && <Loader2 size={14} className="animate-spin" style={{ color: "var(--ft-blue)" }} />}
                {status === "pending" && <Circle size={8} style={{ color: "#9CA3AF", fill: "#9CA3AF" }} />}
              </div>
              <div className="pt-1 flex-1 min-w-0">
                <div
                  className="text-sm font-semibold"
                  style={{
                    color: status === "pending" ? "var(--ft-muted)"
                      : status === "current" ? "var(--ft-blue)"
                      : "var(--ft-charcoal)",
                  }}
                >
                  {m.label}
                </div>
                {status === "current" && (
                  <div className="text-xs text-[var(--ft-muted)] mt-0.5">In progress — your account team is on this now.</div>
                )}
                {status === "done" && (
                  <div className="text-xs text-[var(--ft-muted)] mt-0.5">Complete</div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default ProjectTimeline;
